import "../Sign.css";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../../redux/actions/forgotPassword";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import SignNav from "../../home/Nav/SignNav";
import { Box, Grid, Typography } from "@mui/material";
import { useForm } from "react-hook-form";

function Forgot_Password() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  function onSubmit(data) {
    dispatch(forgotPassword(data.email))
  }
  
  return (
    <div className="sign-container">
      <SignNav />
      <Grid container spacing={6}>
        <Grid item xs={12} md={6}>
          <Box className="sign-form">
            <div className="sign-heading">
              <div>{t("signin.forgotPassword")}</div>
              <div>{t("signin.forgotPasswordDesc")}</div>
            </div>
            <Box
              component="form"
              sx={{ width: { md: "400px" } }}
              className="sign-input"
              onSubmit={handleSubmit(onSubmit)}
            >
              <input
                className="sign-field"
                {...register("email", {
                  required: true,
                  pattern: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                })}
                type="text"
                placeholder={t("common.email")}
              />
              <div className={`input-alert`}>
                {errors.email?.type === "required" && t("errors.emailError")}
              </div>
              <div className={`input-alert`}>
                {errors.email?.type === "pattern" && t("errors.validEmail")}
              </div>

              <button className="button sign-btn" type="submit">
                {t("signin.sendResetLink")}
              </button>
            </Box>
          </Box>
        </Grid>
        
        <Grid
          item
          xs={0}
          md={5}
          sx={{
            mr: 4,
            display: { xs: "none", md: "block" },
          }}
        >
          <div className="signup-image-container">
            <img
              src="/Image/signImage/Signup image new.png"
              alt="forgot password illustration"
              className="signup-main-image"
            />

            <div className="signup-text-container">
              <div className="signup-bottom-text">
                <span className="normal-text">{t("signup.bottomLine1")}</span>
                <span className="highlight-text">
                  {t("signup.bottomLine2")}
                </span>
                <span className="normal-text">{t("signup.bottomLine3")}</span>
              </div>

              <div className="signup-sub-text">
                {t("signup.subLine1")} {t("signup.subLine2")}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (email) => dispatch(forgotPassword(email)),
  };
};

export default connect(null, mapDispatchToProps)(Forgot_Password);